import { Link } from "react-router-dom";

export default function DoNotSellPage() {
  return (
    <div className="legal-page" data-testid="do-not-sell-page">
      <Link to="/" className="ghost-link" style={{ display: "inline-block", marginBottom: 40 }}>Back to Pord.</Link>

      <h1 className="page-title" style={{ fontSize: "clamp(1.8rem,5vw,2.8rem)", marginBottom: 8 }}>Do Not Sell or Share My Personal Information</h1>
      <p className="muted-caption">Effective: April 11, 2026 | Last updated: April 11, 2026</p>

      <h3>Your California Privacy Rights</h3>
      <p>Under the California Consumer Privacy Act (CCPA) and California Privacy Rights Act (CPRA), California residents have the right to opt out of the sale or sharing of their personal information with third parties for cross-context behavioral advertising.</p>

      <h3>What Pord. Collects on This Landing Page</h3>
      <p>At this stage, Pord. collects only:</p>
      <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>Module preference (one selection)</li>
      </ul>
      <p>The Capsule Scenario runs entirely within your browser. No responses or "EXHALE" results are transmitted to our servers.</p>

      <h3>Does Pord. Sell or Share Your Data?</h3>
      <p>Pord. does not sell your personal information.</p>
      <p>However, if we use third-party analytics or advertising tools that qualify as "sharing" under California's broad definition, this page gives you the right to opt out of that activity.</p>

      <h3>How to Submit an Opt-Out Request</h3>
      <p>Email us at info@clarityjournalbyenquips.com with the subject line: "Do Not Sell — Opt-Out Request"</p>
      <p>Include your name and email address. We will process your request within 15 business days and confirm by email.</p>

      <h3>Non-Discrimination</h3>
      <p>Pord. will not discriminate against you for exercising your privacy rights. Opting out has no effect on your waitlist status or future platform access.</p>

      <h3>Additional Privacy Requests</h3>
      <p>For access, correction, or deletion of your data, contact us at info@clarityjournalbyenquips.com or see our full <Link to="/privacy" className="ghost-link" style={{ textDecoration: "underline" }}>Privacy Policy</Link>.</p>

      <div style={{ marginTop: 60 }}>
        <Link to="/" className="cta-pill" data-testid="back-to-pord-btn">Back to Pord.</Link>
      </div>
    </div>
  );
}
